import React, { type FC, useEffect } from 'react'

import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { PageHeader } from 'mailup-web-components'

import setMenuItem from 'Helpers/setMenuItem'

const Header: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  useEffect(() => {
    setMenuItem('RecipientsManageGroups')
  }, [])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
      'data-mu-test': 'breadcrumb-item__recipients',
      onClick: Function.prototype,
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.RecipientsGroups' }),
      'data-mu-test': 'breadcrumb-item__groups',
      url: '#',
      onClick: () => {
        navigate('/recipients/groups/list')
      },
    },
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.StatsRecipientReportRecipientStatus',
      }),
      'data-mu-test': 'breadcrumb-item__groups__groups-overlap',
      onClick: Function.prototype,
    },
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.RecipientsManageGroups' }),
      'data-mu-test': 'topmenu-item__groups__groups-list',
      onClick: () => {
        navigate('/recipients/groups/list')
      },
    },
    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.StatsRecipientReportRecipientStatus',
      }),
      'data-mu-test': 'topmenu-item__groups__groups-overlap',

      isActive: true,
    },
  ].filter((o) => o !== undefined)

  return (
    <PageHeader
      title={intl.formatMessage({
        id: 'Load.NavMenu.StatsRecipientReportRecipientStatus',
      })}
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
    />
  )
}

export default Header
